import React from "react";
import { Link } from "react-router-dom";
import {
  MapPin, Clock, UtensilsCrossed, Sparkles, Euro, Car, Mail, Phone, Building2, ExternalLink,
} from "lucide-react";
import { useLang } from "../LanguageContext";

const ICONS = [Building2, Clock, UtensilsCrossed, Euro, Sparkles, Car];
const FEATURE_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/e6fjcmvk_poule.webp";

export default function Pratique() {
  const { t } = useLang();
  const items = t("pratique.items") || [];

  return (
    <div data-testid="page-pratique">
      <section className="container-page pt-16 sm:pt-24 pb-10">
        <p className="eyebrow mb-4">{t("pratique.eyebrow")}</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-ink max-w-3xl leading-tight">
          {t("pratique.title")}
        </h1>
        <p className="mt-6 text-lg text-ink-muted leading-relaxed max-w-2xl">
          {t("pratique.intro")}
        </p>
      </section>

      <section className="container-page pb-6">
        <div className="max-w-xs mx-auto rounded-[2rem] overflow-hidden shadow-soft bg-cream-100">
          <img
            src={FEATURE_IMG}
            alt="École Pleine Nature — les poules du potager"
            className="w-full h-auto block"
            loading="lazy"
          />
        </div>
      </section>

      <section className="container-page py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = ICONS[i] || Building2;
            return (
              <div key={i} className="card-soft p-8" data-testid={`pratique-${i}`}>
                <Icon size={22} className="text-forest mb-4" />
                <h2 className="font-heading text-xl font-semibold text-ink mb-2">{it.title}</h2>
                <p className="text-sm text-ink-muted leading-relaxed">{it.text}</p>
                {it.link && (
                  <a
                    href={it.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-forest hover:text-forest-dark"
                    data-testid={`pratique-link-${i}`}
                  >
                    <ExternalLink size={14} /> {it.link_label}
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </section>

      <section className="container-page py-12">
        <div className="rounded-[2rem] bg-cream-100 border border-cream-300 p-8 sm:p-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="eyebrow mb-2">{t("pratique.contact_eyebrow")}</p>
            <h2 className="font-heading text-2xl font-semibold text-ink mb-3">
              {t("pratique.contact_school")}
            </h2>
            <div className="space-y-2 text-ink-muted">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 text-forest" />
                <span>{t("pratique.address_l1")}<br />{t("pratique.address_l2")}<br />{t("pratique.address_l3")}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} className="text-forest" />
                <a href="tel:+33980615298" className="hover:text-forest">{t("pratique.phone")}</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} className="text-forest" />
                <a href="mailto:contact@ecolepleinenature.org" className="hover:text-forest">
                  contact@ecolepleinenature.org
                </a>
              </div>
            </div>
          </div>
          <div className="flex md:justify-end">
            <Link to="/contact" className="btn-primary" data-testid="pratique-cta-contact">
              {t("pratique.contact_cta")}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
